import React from 'react'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import axios from 'axios';
import $ from 'jquery';
import cadastrarUsuario from '../../../actions/usuario/cadastrarUsuario'
import alterarUsuario from '../../../actions/usuario/alterarUsuario'
import selecionarPerfis from '../../../actions/perfil/selecionarPerfis';
import limparPerfis from '../../../actions/perfil/limparPerfis';
import {
    renderFieldCheck,
    renderFieldCnpj,
    renderFieldCpf,
    renderFieldEmail,
    renderFieldNumerosPorcentagem,
    renderFieldTelefone,
    required,
    tamanhoPorcentagem,
    validarCNPJ
} from '../../../util/inputs';
import { URL } from '../../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil';
import buscarUsuarioPorEmail from '../../../actions/usuario/buscarUsuarioPorEmail';
import { showSuccessMsg, showAlertMsg } from '../../../util/messagesUtil';
import UsuarioLink from './UsuarioLink';
import { gerarHashForString } from '../../../util/stringUtil';
import Autorizacao from '../../../security/Autorizacao';
import { getAdminEmpresa, getGestorEmpresa, PERFIL_ADMIN } from '../../../security/securityContext';

const TIPOS_PAGAMENTO_USUARIO = [
    { label: 'Cartão de Crédito', value: 'CARTAO_CREDITO' },
    { label: 'Cartão de Débito', value: 'CARTAO_DEBITO' },
    { label: 'PIX', value: 'PIX' },
    { label: 'Dinheiro', value: 'DINHEIRO' },
];

const OPCAO_DESCONTO_MEIA_PASSAGEM = [
    { label: 'Aplicar desconto no valor da Empresa', value: 'EMPRESA' },
    { label: 'Aplicar desconto no valor da ANTT', value: 'ANTT' },
    { label: 'Aplicar desconto no valor da ANTT e Empresa', value: 'ANTT_EMPRESA' }];

export const validate = (values) => {
    const errors = {};
    if (!values.nome) {
        errors.nome = 'Campo obrigatório'
    }
    if (!values.email) {
        errors.email = 'Campo obrigatório'
    }

    return errors
};

const renderField = ({
    input,
    label,
    type,
    css,
    max,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                className={css}
                maxLength={max}
                id={input.name}
                style={{ borderColor: touched && error ? 'red' : '' }}
                disabled={readOnly}
                readOnly={readOnly} />
            {touched
                && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);

export class ModalCadastrarUsuario extends React.Component {
    constructor(props) {
        super(props);
        this.fechar = this.fechar.bind(this);
        this.limparCampos = this.limparCampos.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.submit = this.submit.bind(this);
        this.handleAdicionarPagamentoDesativadoUsuario = this.handleAdicionarPagamentoDesativadoUsuario.bind(this);
        this.handleRemoverPagamentoDesativadoUsuario = this.handleRemoverPagamentoDesativadoUsuario.bind(this);
        this.adicionarDispositivoStone = this.adicionarDispositivoStone.bind(this);
        this.removerDispositivoStone = this.removerDispositivoStone.bind(this);
        this.state = {
            usuario: '',
            tiposQualificacao: [],
            perfisSelecionados: [],
            linksSelecionados: [],
            pagamentosDesativadosUsuario: [],
            dispositivosStoneSelecionados: [],
            novoDispositivoStone: { numeroSerie: '', apelido: '' },
        };
    }

    // Não existe mais um catálogo pré-cadastrado pra escolher -- o admin digita
    // número de série + apelido aqui mesmo (mesmo padrão de UsuarioLink.js: monta
    // uma lista local e só grava tudo de uma vez quando o usuário é salvo).
    adicionarDispositivoStone() {
        const { novoDispositivoStone, dispositivosStoneSelecionados } = this.state;
        if (!novoDispositivoStone.numeroSerie) {
            showAlertMsg('Preencha o número de série da maquininha.');
            return;
        }
        const hash = gerarHashForString(novoDispositivoStone.numeroSerie);
        if (dispositivosStoneSelecionados.find(d => d.hash === hash)) {
            showAlertMsg('Essa maquininha já foi adicionada.');
            return;
        }
        this.setState({
            dispositivosStoneSelecionados: [...dispositivosStoneSelecionados, { hash, ...novoDispositivoStone }],
            novoDispositivoStone: { numeroSerie: '', apelido: '' }
        });
    }

    removerDispositivoStone(hash) {
        this.setState(prev => ({
            dispositivosStoneSelecionados: prev.dispositivosStoneSelecionados.filter(d => d.hash !== hash)
        }));
    }

    componentDidUpdate(prevProps) {
        const isVendedor = (perfis = []) => perfis.some(f =>
            f.value === 'ROLE_VENDEDOR_AGENCIA' ||
            f.value === 'ROLE_VENDEDOR_EMPRESA' ||
            f.value === 'ROLE_OPERADOR_REMARCACAO' ||
            f.value === 'ROLE_ADMIN_EMPRESA'
        );
        const eraVendedor = isVendedor(prevProps.perfisSelecionados);
        const ehVendedor = isVendedor(this.props.perfisSelecionados);
        const form = 'formularioCadastroUsuario';
        // Ao entrar ou sair de um perfil com comissão, os campos partem de 00.00 (continuam editáveis)
        if (eraVendedor !== ehVendedor) {
            this.props.changeFieldValue(form, 'comissao', '00.00');
            this.props.changeFieldValue(form, 'comissaoEncomenda', '00.00');
            this.props.changeFieldValue(form, 'comissaoExcessoBagagem', '00.00');
            this.props.changeFieldValue(form, 'comissaoImpressaoBilhete', '00.00');
            this.props.changeFieldValue(form, 'comissaoEntrega', '00.00');
            this.props.changeFieldValue(form, 'comissaoSeguro', '00.00');
            this.props.changeFieldValue(form, 'impostoRetido', '00.00');
        }
        if (!eraVendedor && ehVendedor && !this.props.opcaoDescontoMeiaPassagem) {
            this.props.changeFieldValue(form, 'opcaoDescontoMeiaPassagem',
                { label: 'Aplicar desconto no valor da ANTT', value: 'ANTT' });
        }
    }

    handleAdicionarPagamentoDesativadoUsuario(option) {
        this.setState(prev => {
            if (prev.pagamentosDesativadosUsuario.find(p => p.value === option.value)) return prev;
            return { pagamentosDesativadosUsuario: [...prev.pagamentosDesativadosUsuario, option] };
        });
    }

    handleRemoverPagamentoDesativadoUsuario(option) {
        this.setState(prev => ({
            pagamentosDesativadosUsuario: prev.pagamentosDesativadosUsuario.filter(p => p.value !== option.value),
        }));
    }

    exibirComboOpcaoDescontoMeiaPassagem(event) {
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Adicionar uma opção de desconto'
                    options={OPCAO_DESCONTO_MEIA_PASSAGEM}
                    onChange={(value) => {
                        event.input.onChange(value);
                    }}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                    && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirComboPerfil(event) {
        const { perfis } = this.props
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Adicionar um perfil...'
                    options={perfis}
                    onChange={(value) => {
                        event.input.onChange(value);
                        this.adicionarPerfil(value)
                    }}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                    && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirOpcaoDescontoMeiaPassagemo() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            return (
                <div className="form-row mt-2">
                    <div className="col-12 col-sm-9 col-md-6">
                        <label>Opções de desconto de meia passagem </label>
                        <Field name='opcaoDescontoMeiaPassagem' required={true}
                            component={this.exibirComboOpcaoDescontoMeiaPassagem.bind(this)} />
                    </div>
                </div>
            )
        }
        return ''
    }

    adicionarPerfil(perfil) {
        if (this.props.idUsuario) {
            const url = `${URL}/perfil/${perfil.value}/usuario/${this.props.idUsuario}/empresa/${this.props.empresaSelecionada.id}/adicionar`;
            axios.post(url, SLOW_REQUEST_CONFIG)
                .then((resp) => {
                    if (resp.status === 200) {
                        const perfis = Object.assign([], this.props.perfisSelecionados);
                        const perfiJaExiste = perfis.filter(f => f.value === perfil.value);
                        if (perfiJaExiste.length === 0) {
                            perfis.push(perfil);
                            this.props.selecionarPerfis(perfis)
                        }
                    }
                })
        } else {
            const perfis = Object.assign([], this.props.perfisSelecionados);
            const perfiJaExiste = perfis.filter(f => f.value === perfil.value);
            if (perfiJaExiste.length === 0) {
                perfis.push(perfil);
                this.props.selecionarPerfis(perfis)
            }
        }
    }

    exibirAcrescimoMaximoPassagem() {
        return (
            <div className="form-row mt-2">
                <div className="col-12 col-sm-6 col-md-6">
                    <Field name='acrescimoMaximoPassagem' validate={[tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label=" Acréscimo Máximo de Passagem(%)" />
                </div>
            </div>
        )
    }

    exibirComissao() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="col-12 col-md-2">
                    <label>Comissão(%)</label>
                    <input type="text" className="form-control" readOnly={true} value='10.00' name='comissao' />
                </div>
            }
            return  <div className='col-12 col-md-2' style={{paddingTop: '22px'}}>
                <Field name='comissao' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                        css="form-control" label="Comissão(%)" />
            </div>
        }
        return ''
    }

    exibirComissaoEncomenda() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="form-group col-12 col-md-2">
                    <label>C.Encomenda(%)</label>
                    <input type="text" className="form-control" readOnly={true} value='10.00' name='comissaoEncomenda' />
                </div>
            }
            return <div className='col-12 col-md-2' style={{paddingTop: '22px'}}>
                    <Field name='comissaoEncomenda' disabled validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Encomenda(%)" />
                </div>
        }
        return ''
    }

    exibirComissaoExcessoBagagem() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="form-group col-12 col-md-2">
                    <label>C.Excesso Bagagem(%)</label>
                    <input type="text" className="form-control" readOnly={true} value='10.00' name='comissaoExcessoBagagem' />
                </div>
            }
            return <div className='col-12 col-md-2'>
                <Field name='comissaoExcessoBagagem' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Excesso Bagagem(%)" />
            </div>
        }
        return ''
    }

    exibirComissaoImpressaoBilhete() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="form-group col-12 col-md-2">
                    <label>C.Impressao Bilhete(%)</label>
                    <input type="text" className="form-control" readOnly={true} value='10.00' name='comissaoImpressaoBilhete' />
                </div>
            }
            return <div className='col-12 col-md-2'>
                <Field name='comissaoImpressaoBilhete' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label="C.Impressao Bilhete(%)" />
            </div>
        }
        return ''
    }

    exibirComissaoEntrega() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="form-group col-12 col-md-2">
                    <label>C.Entrega(%)</label>
                    <input type="text" className="form-control" readOnly={true} value='10.00' name='comissaoEntrega' />
                </div>
            }
            return <div className='col-12 col-md-2'>
                <Field name='comissaoEntrega' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label="C.Entrega(%)" />
            </div>
        }
        return ''
    }

    exibirComissaoSeguro() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="form-group col-12 col-md-2">
                    <label>C.Seguro(%)</label>
                    <input type="text" className="form-control" readOnly={true} value='10.00' name='comissaoSeguro' />
                </div>
            }
            return <div className='col-12 col-md-2'>
                <Field name='comissaoSeguro' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label="C.Seguro(%)" />
            </div>
        }
        return ''
    }

    exibirImpostoRetidoUsuaio() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB' || this.props.empresaSelecionada.grupo === 'BUSER' || this.props.empresaSelecionada.grupo === 'CIDAO') {
                if (this.props.empresaSelecionada.id == 808) {
                    return <div className="form-group">
                        <label>Imposto retido(%)</label>
                        <input type="text" className="form-control col-md-2" readOnly={true} value='0.00' name='impostoRetido' />
                    </div>
                }

                return <div className="form-group">
                    <label>Imposto retido(%)</label>
                    <input type="text" className="form-control col-md-2" readOnly={true} value='16.25' name='impostoRetido' />
                </div>
            } else
                return <div className="form-group">
                    <Field name='impostoRetido' validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control col-md-2" label="imposto retido(%)" />
                </div>
        }
        return ''
    }

    montarParametroUsuario(values) {
        const comissoes = [{ tipoServico: 'RESERVA', porcentagem: values.comissao }, { tipoServico: 'ENCOMENDA', porcentagem: values.comissaoEncomenda },
            { tipoServico: 'EXCESSO_BAGAGEM', porcentagem: values.comissaoExcessoBagagem },  { tipoServico: 'IMPRESSAO_BILHETE', porcentagem: values.comissaoImpressaoBilhete },
            { tipoServico: 'ENTREGA_ENCOMENDA', porcentagem: values.comissaoEntrega },
            { tipoServico: 'SEGURO', porcentagem: values.comissaoSeguro }
        ].filter(c => c.porcentagem !== undefined && c.porcentagem !== null && c.porcentagem !== ''); // remove comissões não preenchidas (perfil sem exigência de comissão)
        
        return {
            idAgencia: values.agencia ? values.agencia.value : null,
            id: values.idUsuario,
            nome: values.nome,
            email: values.email,
            roles: this.props.perfisSelecionados.map(perfil => perfil.value),            
            comissoes: comissoes,
            impostoRetido: values.impostoRetido,
            telefone: values.telefoneUsuario,
            cpf: values.cpf,
            venderCte: values.venderCte,
            venderValorANTT: values.venderValorANTT,
            vendeGratuidade: values.vendeGratuidade,
            vendaTEF: values.vendaTEF,
            cnpjTef: values.numeroCnpjTef,
            storeIdTef: values.storeIdTef,
            habilitadoLinkPagamento: values.habilitadoLinkPagamento,            
            habilitadoCieloEcommerce: values.habilitadoCieloEcommerce,
            habilitadoSicoob: values.habilitadoSicoob,
            habilitadoStoneConnect: values.habilitadoStoneConnect,
            tipoDescontoMeiaPassagem: values.opcaoDescontoMeiaPassagem ? values.opcaoDescontoMeiaPassagem.value : 'EMPRESA',
            links: this.state.linksSelecionados,
            acrescimoMaximoPassagem: values.acrescimoMaximoPassagem || '00.00',
            habilitadoBloqueioEdicaoPassageiro: values.habilitadoBloqueioEdicaoPassageiro,
            habilitadoBloqueioReimpressaoCupom: values.habilitadoBloqueioReimpressaoCupom,
            habilitadoComissionamentoReimpresaoPassagem: values.habilitadoComissionamentoReimpresaoPassagem,
            habilitadoBloqueioListaPassageiro: values.habilitadoBloqueioListaPassageiro,
            habilitadoBloqueioBuscarReservasTerceiros: values.habilitadoBloqueioBuscarReservasTerceiros,
            habilitadoAcessoEncomenda: values.habilitadoAcessoEncomenda,
            habilitadoVendaOffline: values.habilitadoVendaOffline || false,
            habilitadoVendaUrbana: values.habilitadoVendaUrbana || false,
            habilitadoEncomendaAvulsa: values.habilitadoEncomendaAvulsa || false,
            habilitadoComissaoEntregaEncomenda: values.habilitadoComissaoEntregaEncomenda || false,
            habilitadoAcessoPassagens: values.habilitadoAcessoPassagens,
            usuarioSistema: values.usuarioSistema,
            pagamentosDesativados: this.state.pagamentosDesativadosUsuario.map(p => p.value),
            dispositivosStone: this.state.dispositivosStoneSelecionados.map(d => ({ numeroSerie: d.numeroSerie, apelido: d.apelido }))
        };
    }

    submit(values) {
        this.props.cadastrarUsuario(this.montarParametroUsuario(values), this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Usuario cadastrado com sucesso');
                this.limparFormulario();
                this.fecharModal();
            })
    }

    fecharModal() {
        $('#modalCadastrarUsuario')
            .modal('hide');
        $('#modalCadastrarUsuario')
            .hide();
        $('.modalCadastrarUsuario')
            .hide();
    }

    limparFormulario() {
        this.props.reset('formularioCadastroUsuario');
        this.setState({ perfisSelecionados: [], usuario: '', linksSelecionados: [], dispositivosStoneSelecionados: [] });
        this.props.limparPerfis();
        this.limparLinks();
        this.props.buscarUsuario();
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroUsuario',
            'nome', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'nomeUsuario', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'email', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'comissao', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'impostoRetido', '');
        this.setState({ usuario: null });
        this.props.limparPerfis();
    }

    removerPerfil(perfil) {
        const perfis = Object.assign([], this.props.perfisSelecionados);
        const novaLista = perfis.filter(f => f.value !== perfil.value);
        this.props.selecionarPerfis(novaLista)
    }


    exibirPerfisSelecionados() {
        if (this.props.perfisSelecionados) {
            return this.props.perfisSelecionados.map(perfil => (
                <div key={perfil.value} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', padding: '4px 10px', background: '#f5f5f5', borderRadius: '4px' }}>
                    <span style={{ flex: 1, fontSize: '13px' }}>{perfil.label}</span>
                    <i className="material-icons" style={{ cursor: 'pointer', fontSize: '18px', color: '#e53935' }}
                        onClick={() => this.removerPerfil(perfil)}>delete</i>
                </div>
            ))
        }
        return ''
    }

    alterarValoresLinksSelecionados(links) {
        this.setState({ linksSelecionados: links });
    }

    limparLinks() {
        this.setState({ linksSelecionados: [] });
    }

    buscarUsuarioPorEmail(email) {
        if (email) {
            this.props.buscarUsuarioPorEmail(email, this.props.empresaSelecionada.id)
                .then((resp) => {
                    if (resp.payload.status === 200) {
                        if (resp.payload.data) {
                            this.props.changeFieldValue('formularioCadastroUsuario', 'nome', resp.payload.data.nome);
                            this.props.changeFieldValue('formularioCadastroUsuario', 'cpf', resp.payload.data.cpfCnpj);
                            this.props.changeFieldValue('formularioCadastroUsuario', 'telefoneUsuario', resp.payload.data.telefone);
                            const perfis = [];
                            resp.payload.data.rolesName.map(pf => perfis.push({
                                label: pf.descricao,
                                value: pf.valor
                            }));
                            this.props.selecionarPerfis(perfis);
                            this.setState({ usuario: resp.payload.data })
                        } else {
                            this.props.changeFieldValue('formularioCadastroUsuario', 'nome', '');
                            this.props.changeFieldValue('formularioCadastroUsuario', 'cpf', '');
                            this.props.changeFieldValue('formularioCadastroUsuario', 'telefoneUsuario', '');
                            this.setState({ usuario: '' })
                        }
                    }
                })
        }
    }

    fechar() {
        this.setState({ paginaAtual: 1 });
        this.limparFormulario();
        this.props.limparPerfis();
    }

    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return (
            <div className="modal fade show" id='modalCadastrarUsuario' role='dialog'
                aria-labelledby='modalCadastrarUsuario' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-icon">
                                <i className="material-icons">person_add</i>
                            </div>
                            <div>
                                <h5 className="vx-modal-title">Novo Usuário</h5>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                onClick={() => this.fechar()}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="vx-modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="email" type="email" component={renderFieldEmail} label="E-mail:"
                                            css="form-control" readOnly={false} validate={[required]}
                                            onBlur={e => this.buscarUsuarioPorEmail(e.target.value)} />
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="cpf" type="text" component={renderFieldCpf} label="CPF:"
                                            validate={[required]}
                                            css="form-control" readOnly={this.state.usuario} />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <Field name="nome" type="text" validate={[required]} component={renderField}
                                            label="Nome Completo:"
                                            css="form-control" readOnly={this.state.usuario} />
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-3">
                                        <Field name="telefoneUsuario" type="text"
                                            component={renderFieldTelefone}
                                            css="form-control" label="Telefone" readOnly={this.state.usuario} />
                                    </div>
                                </div>

                                <div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-6">
                                            <label>Perfil usuário</label>
                                            <Field id='perfil' name='perfil'
                                                component={this.exibirComboPerfil.bind(this)} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-6">
                                            <div>
                                                {this.exibirPerfisSelecionados()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='venderCte' type="checkbox" component={renderFieldCheck}
                                                label="Vender com cte"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='venderValorANTT' type="checkbox" component={renderFieldCheck}
                                                label="Vender com valor antt"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-9">
                                                <Field name='usuarioSistema' type="checkbox" component={renderFieldCheck}
                                                    label="Usuário de Sistema (integração)"
                                                    css="form-check-input" readOnly={false} />
                                            </div>
                                        </div>
                                    </Autorizacao>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='vendeGratuidade' type="checkbox" component={renderFieldCheck}
                                                label="Vender Gratuidade"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>                                    
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioEdicaoPassageiro' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Edição de Passagens"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioReimpressaoCupom' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Impressão de Passagens"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioListaPassageiro' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear lista de passageiro"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioBuscarReservasTerceiros' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Cancelar/Remarcar/Em Aberto Reservas de Terceiros"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='vendaTEF' type="checkbox" component={renderFieldCheck}
                                                label="Vender TEF"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    {!(this.props.pagamentosDesativados || []).includes('LINK_PAGAMENTO') && (
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoLinkPagamento' type="checkbox" component={renderFieldCheck}
                                                label="Vender Link Pagamento"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    )}
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoCieloEcommerce' type="checkbox" component={renderFieldCheck}
                                                label="Venda via PIX (Cielo E-commerce)"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoSicoob' type="checkbox" component={renderFieldCheck}
                                                label="Venda via PIX (Sicoob)"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,getAdminEmpresa(this.props.empresaSelecionada.id)
                                                                            ,getGestorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-9">
                                                <Field name='habilitadoStoneConnect' type="checkbox" component={renderFieldCheck}
                                                    label="Venda via Connect Stone"
                                                    css="form-check-input" readOnly={false} />
                                            </div>
                                        </div>
                                        
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-9">
                                                <label className='mt-2'>Maquininhas Stone deste usuário</label>
                                                <div className="form-row">
                                                    <div className="form-group col-5">
                                                        <label>Número de série (devices_serial_number)</label>
                                                        <input className="form-control" type="text" placeholder="Número de série"
                                                            value={this.state.novoDispositivoStone.numeroSerie}
                                                            onChange={e => this.setState({ novoDispositivoStone: { ...this.state.novoDispositivoStone, numeroSerie: e.target.value } })} />
                                                    </div>
                                                    <div className="form-group col-5">
                                                        <label>Apelido (uso interno, não enviado à Stone)</label>
                                                        <input className="form-control" type="text" placeholder="Ex.: Balcão 1"
                                                            value={this.state.novoDispositivoStone.apelido}
                                                            onChange={e => this.setState({ novoDispositivoStone: { ...this.state.novoDispositivoStone, apelido: e.target.value } })} />
                                                    </div>
                                                    <div className="form-group col-2 d-flex align-items-end">
                                                        <button type="button" className="btn btn-laranja btn-sm mb-3" onClick={this.adicionarDispositivoStone}>
                                                            + Adicionar
                                                        </button>
                                                    </div>
                                                </div>
                                                <table className="table table-sm table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Número de série</th>
                                                            <th scope="col">Apelido</th>
                                                            <th scope="col"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.dispositivosStoneSelecionados.length === 0 ? (
                                                            <tr className="alert alert-warning text-center" role="alert">
                                                                <td colSpan="3">Nenhuma maquininha adicionada.</td>
                                                            </tr>
                                                        ) : this.state.dispositivosStoneSelecionados.map(d => (
                                                            <tr key={d.hash}>
                                                                <td>{d.numeroSerie}</td>
                                                                <td>{d.apelido}</td>
                                                                <td className="text-center" style={{ cursor: 'pointer', color: 'red' }}>
                                                                    <div onClick={() => this.removerDispositivoStone(d.hash)}>
                                                                        Remover
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </Autorizacao>

                                    {this.props.vendaTEF ? <><div className="form-row mb-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name="numeroCnpjTef" css='form-control' validate={[required, validarCNPJ]}
                                                component={renderFieldCnpj} label="Número CNPJ"/>
                                        </div>
                                    </div>
                                    <div className="form-row mb-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name="storeIdTef" type="text"
                                                component={renderField}                                
                                                label="Store ID TEF"
                                                css="form-control col-md-4"
                                                validate={[required]}
                                            />
                                        </div>
                                    </div></>: ''}
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoComissionamentoReimpresaoPassagem' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Comissao Sobre Passagens Reimpressas de Terceiros"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoAcessoEncomenda' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Acesso Encomenda"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoAcessoPassagens' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Acesso Módulo de Passagens"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>

                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoVendaOffline' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Venda Offline"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoVendaUrbana' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Vendas Urbanas"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoEncomendaAvulsa' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Encomenda Avulsa"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoComissaoEntregaEncomenda' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Comissão de Entrega de Encomenda"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <label className='mt-2'>Pagamentos Desativados (Usuário)</label>
                                            <Select
                                                placeholder='Selecione o Tipo de Pagamento'
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        height: 35,
                                                        minHeight: 32,
                                                        fontSize: 16,
                                                        width: '100%',
                                                        borderColor: '#e4e7ea',
                                                        cursor: 'pointer'
                                                    })
                                                }}
                                                noOptionsMessage={() => 'Nenhuma opção disponível'}
                                                options={TIPOS_PAGAMENTO_USUARIO
                                                    .filter(tp => !(this.props.pagamentosDesativados || []).includes(tp.value))
                                                    .filter(tp => !this.state.pagamentosDesativadosUsuario.find(p => p.value === tp.value))
                                                }
                                                value={null}
                                                onChange={e => this.handleAdicionarPagamentoDesativadoUsuario(e)}
                                            />
                                            <div className="mt-1">
                                                {this.state.pagamentosDesativadosUsuario.map(p => (
                                                    <span key={`pdu_${p.value}`} className="badge badge-secondary mr-1" style={{ cursor: 'pointer' }}
                                                        onClick={() => this.handleRemoverPagamentoDesativadoUsuario(p)}>
                                                        {p.label} &times;
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    {this.exibirAcrescimoMaximoPassagem()}
                                    <div className="form-row">
                                        {this.exibirComissao()}
                                        {this.exibirComissaoEncomenda()}
                                        {this.exibirComissaoExcessoBagagem()}
                                        {this.exibirComissaoImpressaoBilhete()}
                                        {this.exibirComissaoEntrega()}
                                        {this.exibirComissaoSeguro()}
                                    </div>
                                    {this.exibirImpostoRetidoUsuaio()}
                                    {this.exibirOpcaoDescontoMeiaPassagemo()}
                                </div>

                                <div className="form-row">
                                    <UsuarioLink
                                        linksSelecionados={this.state.linksSelecionados}
                                        alterarValoresLinksSelecionados={this.alterarValoresLinksSelecionados.bind(this)}
                                        verificaSeNaoFoiAlteradoLinks={null}
                                        classCss={'campoUrl'}
                                        ehUsuarioAgencia={false}
                                    />
                                </div>

                                <div className="form-group area-codigo">
                                    <Field name="idUsuario" type="hidden" component={renderField}
                                        css="form-control col-md-12" />
                                </div>
                                <div className="vx-modal-footer">
                                    <button id="btn-salvar" type="submit" disabled={invalid || submitting}
                                        className="vx-btn-primary">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            acrescimoMaximoPassagem: '00.00',
            habilitadoAcessoPassagens: true
        },
        opcaoDescontoMeiaPassagem: formValueSelector('formularioCadastroUsuario')(state, 'opcaoDescontoMeiaPassagem'),
        habilitadoStoneConnectUsuario: formValueSelector('formularioCadastroUsuario')(state, 'habilitadoStoneConnect'),
        perfisSelecionados: state.perfisSelecionados,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualUsuario,
        registrosPorPagina: state.registrosPorPaginaUsuario,
        usuarioSistema: state.usuarioSelecionado ? state.usuarioSelecionado.usuarioSistema : '',
        pagamentosDesativados: state.pagamentosDesativados ? state.pagamentosDesativados.pagamentosDesativados : [],
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarUsuario,
        selecionarPerfis,
        buscarUsuarioPorEmail,
        alterarUsuario,
        limparPerfis
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroUsuario'
})(ModalCadastrarUsuario));
